'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

const SheetContext = React.createContext({});

exports.default = SheetContext;
//# sourceMappingURL=SheetContext.js.map
